import { render } from "./Edit.vue?vue&type=template&id=db6925f4&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=db6925f4&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db6925f4"],['__file',"resources/js/pages/cantine/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "db6925f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('db6925f4', __exports__)) {
    console.log('reload')
    api.reload('db6925f4', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=db6925f4&scoped=true", () => {
    console.log('re-render')
    api.rerender('db6925f4', render)
  })

}


export default __exports__